// extracted by mini-css-extract-plugin
export default {"btn":"TOCEntry_btn__z9gjJ","dropdownItem":"TOCEntry_dropdownItem__J77C-","level0":"TOCEntry_level0__JU-1A","level1":"TOCEntry_level1__fz5Z8","level2":"TOCEntry_level2__SzEky"};